var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation",class:{
    'confirmation--offline': _vm.offline,
  }},[_c('div',[_c('HdButton',{staticClass:"confirmation__print-button",attrs:{"modifier":"primary","icon-src":_vm.download,"type":"button"},on:{"click":_vm.printPage}},[_vm._v(" "+_vm._s(_vm.$t('WIZARD.CONFIRMATION.PRINT_BUTTON'))+" ")])],1),_c('EvaluationReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }